import { useState } from "react";
import { ArrowUp } from "lucide-react";
import { useAIWorkspace } from "@/hooks/useAIWorkspace";

const CHIPS = [
  ["Which roles fit me best?", "Which open roles fit my profile best, and why?"],
  ["Improve my headline", "Suggest a stronger headline for my profile based on my experience."],
  ["Practice interview", "Run a short practice interview with me for my top-matching role."],
];

export function HomeCopilot({ hint }) {
  const [q, setQ] = useState("");
  const open = useAIWorkspace();
  const send = (p) => open(p, { previewUrl: "/candidate" });
  return (
    <form className="hs-card p-4 sm:p-5 transition-colors focus-within:border-primary/40" data-testid="home-copilot"
      onSubmit={(e) => { e.preventDefault(); send(q); }}>
      <label htmlFor="home-copilot-input" className="sr-only">Ask Career Copilot</label>
      <textarea id="home-copilot-input" rows={1} value={q} onChange={(e) => setQ(e.target.value)} data-testid="home-copilot-input"
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(q); } }}
        placeholder={`Ask Copilot: "${hint}"`}
        className="w-full resize-none bg-transparent text-[15px] leading-relaxed placeholder:text-muted-foreground/80 focus:outline-none focus-visible:outline-none" />
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {CHIPS.map(([label, prompt], i) => (
          <button type="button" key={label} onClick={() => send(prompt)} className="hs-chip" data-testid={`home-copilot-chip-${i}`}>{label}</button>
        ))}
        <button type="submit" disabled={!q.trim()} aria-label="Send to Copilot" data-testid="home-copilot-send"
          className="ml-auto h-9 w-9 rounded-lg bg-primary/15 text-primary flex items-center justify-center hover:bg-primary/25 disabled:opacity-40 transition-colors">
          <ArrowUp className="h-4 w-4" />
        </button>
      </div>
    </form>
  );
}
